import React from 'react';
import logErrorForCloudWatch from '../helpers/awsCloudwatchLogs';
import AoErrorLogo from '../assets/images/ao-error-logo.png';
import SupportForm from './SupportForm/';
import dataModel from '../models/DataModel';
import './ErrorBoundary.scss';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: {} };

    this.handleGoToCompanies = this.handleGoToCompanies.bind(this);
    this.handleGoToProjects = this.handleGoToProjects.bind(this);
    this.handleGoToTasks = this.handleGoToTasks.bind(this);
    this.handleZenDesk = this.handleZenDesk.bind(this);
    this.handleZenDeskClose = this.handleZenDeskClose.bind(this);
    this.handleGoToManagerDashboard = this.handleGoToManagerDashboard.bind(this);
    this.handleGoToMobileDashboard = this.handleGoToMobileDashboard.bind(this);
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    if (error.message == 'Failed to execute \'removeChild\' on \'Node\': The node to be removed is not a child of this node.') {
      return { hasError: false };
    }
    else {
      return { hasError: true };
    }
  }

  componentDidCatch(error, errorInfo) {
    if (error.message != 'Failed to execute \'removeChild\' on \'Node\': The node to be removed is not a child of this node.') {
      let zenDeskAdditionalInfo = 'An uncaught error occurred. Error: ' + error.messager + ' Stack Trace: ' + error.stack;
      this.setState({ error, zenDeskAdditionalInfo });
      this.handleError('UNCAUGHT', 'An uncaught javascript error occurred, handled by ErrorBoundary', error.stackTrace);
    }
  }

  handleError(type, message, source, lineno, colno, error) {
    dataModel.mobileBridge.fireNativeEvent('hybrid.debugInfo', {
      data: { info: 'App Error **********: ' + message },
    });

    const appState = dataModel.store.getState();
    const { currentUser } = appState.new_users;
    const { currentCompany } = appState.new_companies;

    const onMobile = dataModel.mobileBridge.isMobile;

    const errorInfoObject = {
      spaVersion: process.env.VERSION,
      type,
      message,
      error,
      currentUser,
      currentCompany,
      onMobile,
      source,
    };

    logErrorForCloudWatch(errorInfoObject);
  }

  handleGoToManagerDashboard() {
    this.setState({ hasError: false });
    window.location = '/manager-dashboard/dashboard'
  }
  handleGoToProjects() {
    this.setState({ hasError: false });
    window.location = '/projects/summary';
  }

  handleGoToCompanies() {
    this.setState({ hasError: false });
    window.location = '/companies';
  }

  handleGoToTasks() {
    this.setState({ hasError: false });
    window.location = '/tasks/project/all';
  }

  handleZenDesk() {
    this.setState({ doZenDeskReport: true });  
  }

  handleZenDeskClose() {
    this.setState({ doZenDeskReport: false });  
  }

  handleGoToMobileDashboard() {
    this.setState({ hasError: false });
    window.location = '/dashboard';
  }

  render() {
    if (this.state.hasError) {
      const appState = dataModel.store.getState();
      const { currentUser } = appState.new_users;
      let adminLinks = null;
      if (currentUser && (currentUser.super_admin || (currentUser.role && (currentUser.role.name == 'admin' || currentUser.role.name == 'editor')))) {
        adminLinks = (
          <div>
            <div className="choice" onClick={this.handleGoToManagerDashboard}>Go to the Manager Dashboard</div>
            <div className="choice" onClick={this.handleGoToProjects}>Go to the Projects Page</div>
            <div className="choice" onClick={this.handleGoToCompanies}>Go to the Companies Page</div>
          </div>
        );
      }
      let errorMessage = this.state.error.message;
      return (<div className="error-page-boundary">
        <div className="header">Whoops! Something's gone wrong.</div>
        <img alt="Logo" className="logo" src={AoErrorLogo} />
        <div className="details">
            <p className='title'>There was an uncaught javascript exception</p>
            <p className='message'>{errorMessage}</p>
            {dataModel.mobileBridge.isMobile ? 
              <div className="choices">
              <div className="caption">What would you like to do?</div>
              <div className="choice" onClick={this.handleZenDesk}>Report Error</div>
              <div className="choice" onClick={this.handleGoToMobileDashboard}>Go to the Dashboard</div>
            </div>
            :
              <div className="choices">
                <div className="caption">What would you like to do?</div>
                <div className="choice" onClick={this.handleZenDesk}>Report Error</div>
                {adminLinks}
                <div className="choice" onClick={this.handleGoToTasks}>Go to the Tasks Page</div>
              </div>
            }
        </div>
          <SupportForm zenDeskAdditionalInfo={this.state.zenDeskAdditionalInfo} initializeExpanded={this.state.doZenDeskReport}
            onClose={this.handleZenDeskClose}/>
      </div>);
    }

    return this.props.children; 
  }
}



// WEBPACK FOOTER //
// ./src/components/ErrorBoundary.js